import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SidebarMenus from '../components/SidebarMenus';
import api from '../utils/api';
import '../assets/styles/dashboard.css';
import '../assets/styles/create-booking.css';
import '../assets/styles/booking-history.css';
import Header from '../components/Header';
import SweetAlert from '../components/SweetAlert';

const CURRENCY = process.env.REACT_APP_CURRENCY_SYMBOL || '$';


const PRIMARY_REASONS = [
  { id: 'could_not_find_driver', label: 'Could not find driver' },
  { id: 'driver_asked_cancel', label: 'Driver asked me to cancel' },
  { id: 'driver_not_closer', label: 'Driver not getting closer' },
  { id: 'driver_behavior', label: 'Driver behavior' },
  { id: 'wait_time_long', label: 'Wait time too long' },
  { id: 'other', label: 'Other' },
];

const OTHER_REASONS = [
  { id: 'vehicle_cleanliness', label: 'Vehicle Cleanliness' },
  { id: 'no_seat_belt', label: 'No seat belt' },
  { id: 'unable_contact', label: 'Unable to contact driver' },
  { id: 'safety_issues', label: 'Safety issues' },
  { id: 'change_of_plan', label: 'Change of plan' },
];


const BookingDetails = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get('id');
  console.log("id..................", id);
  //const status = searchParams.get('status');   // optional future param
  //const from = searchParams.get('from');       // optional future param
  const agencyData = JSON.parse(localStorage.getItem('agencyData') || '{}');
  const partnerName = agencyData.companyName || 'Partner';
  const partnerEmail = agencyData.email || '';
  const initials = partnerName.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [showOtherReasons, setShowOtherReasons] = useState(false);
  const [otherNote, setOtherNote] = useState('');
  const [cancelling, setCancelling] = useState(false);
  const [otherReasons, setOtherReasons] = useState(OTHER_REASONS);
  const [primaryReasons, setPrimaryReasons] = useState(PRIMARY_REASONS);




  //const booking = useMemo(() => BOOKING_DETAILS[id] || BOOKING_DETAILS['TXB-4820'], [id]);
  const [booking, setBooking] = useState(null);
  // get dynamic 
  useEffect(() => {

    api.post(`/api/website/booking-details`, { rideId: id }).then((res) => {
      console.log("booking details..................", res.data.data);
      setBooking(res.data.data);
    });
  }, [id]);

  useEffect(() => {

    const token = localStorage.getItem('token');
    if (!token) navigate('/');
  }, [navigate]);

  const statusClass = booking?.status
    ? booking.status.toLowerCase().replace(/\s+/g, '-')
    : '';

  const handleSelectReason = (reason) => {
    setOtherNote(''); // clear textarea on any list click
    if (reason.id === 'other') {
      setShowOtherReasons(true);
      setSelectedReason('other');
      // remove "Other" from the visible primary list
      //setPrimaryReasons(PRIMARY_REASONS.filter((r) => r.id !== 'other'));
    } else {
      setSelectedReason(reason.id);
      // optional: keep extra reasons visible, or hide them again
    }
  };
  const canSubmit =
    !cancelling &&
    (
      (selectedReason && selectedReason !== 'other') ||
      (selectedReason === 'other' && otherNote.trim().length > 0)
    );

  const handleCancelRide = async () => {
    let message = '';
    if (!selectedReason) {
      SweetAlert.error('Please select a reason for cancelling the ride');
      return;
    }
    if (selectedReason === 'other' && !otherNote.trim()) {
      SweetAlert.error('Please provide details of the reason of cancellation');
      return;
    }

    if (selectedReason === 'other') {
      message = otherNote;
    }
    else {
      // get the label of the selected reason
      let reason = primaryReasons.find((r) => r.id === selectedReason);
      if (!reason) {
        reason = otherReasons.find((r) => r.id === selectedReason);
      }
      message = reason.label;
    }
    setCancelling(true);
    try {

      const payload = {
        rideid: id,
        userId: booking?.userId,
        type: 'Cancel',
        reason: message,
        disputeReason: "",
      }
      console.log("payload..................", payload);
      const response = await api.post('/api/website/cancel-ride', payload);
      console.log("response..................", response);
      if (response.data.status === 1) {
        SweetAlert.success('Booking cancelled successfully');
        setShowCancelModal(false);
      } else {
        SweetAlert.error('Failed to cancel booking');
      }

      navigate('/booking-history');
    } catch (err) {
      SweetAlert.error(err.response.data.message);
      console.log("error..................", err);
    } finally {
      setCancelling(false);
    }
  };

  return (

    <div className="dashboard-layout">
      <SidebarMenus partnerName={partnerName} partnerEmail={partnerEmail} />

      <main className="dashboard-main">
        <Header title="Booking Details" search={false} bell={true} partnerName={partnerName} initials={initials} searchPlaceholder="Search bookings, customers..." />

        <div className="bd-topbar">
          <div className="bd-topbar-left">
            <button type="button" className="bd-back" onClick={() => navigate('/booking-history')}>
              ← Back
            </button>
            <strong className="bd-id">{booking?.id || ''}</strong>
            <span className={`bh-status ${statusClass}`}>
              <span className="bh-status-dot" />
              {booking?.status || ''}
            </span>
          </div>
          <div className="bd-topbar-actions">
            {/* <button type="button" className="bh-btn-outline">✎ Modify</button> */}
            {booking?.status === 'Pending' && (
              <button
                type="button"
                className="bd-btn-danger"
                onClick={() => setShowCancelModal(true)}
              >
                Cancel Booking
              </button>
            )}
          </div>
        </div>

        <div className="bd-grid">
          <div className="bd-main-col">
            <section className="bd-card">
              <h3>Booking Timeline</h3>
              <div className="bd-timeline">
                {booking?.timeline && booking.timeline.length > 0 && booking.timeline.map((step, i) => (
                  <div key={step.label} className={`bd-step${step.done ? ' done' : ''}${i === booking.timeline.length - 1 ? ' last' : ''}`}>
                    <div className="bd-step-marker">{step.done ? '✓' : ''}</div>
                    <div className="bd-step-content">
                      <div className="bd-step-label">{step.label}</div>
                      {step.time && <div className="bd-step-time">{step.time}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="bd-card">
              <h3>Booking Information</h3>
              <div className="bd-info-grid">
                <div>
                  <div className="bd-info-label">Customer</div>
                  <div className="bd-info-value">{booking?.customerName || ''}</div>
                  <div className="bh-muted">{booking?.phone || ''}</div>
                </div>
                {/* flight detail only when airport ride */}
                {booking && booking?.flight && (
                  <div>
                    <div className="bd-info-label">Flight Details</div>
                    <div className="bd-info-value">{booking?.flight || ''}</div>
                  </div>

                )}

                <div>
                  <div className="bd-info-label">Pickup</div>
                  <div className="bd-info-value">{booking?.pickup || ''}</div>
                  <div className="bh-muted">{booking?.pickupDateTime || ''}</div>
                </div>
                <div>
                  <div className="bd-info-label">Dropoff</div>
                  <div className="bd-info-value">{booking?.dropoff || ''}</div>
                </div>
                <div>
                  <div className="bd-info-label">Fare</div>
                  <div className="bd-info-value bd-fare">{CURRENCY} {booking?.fare || ''}</div>
                </div>
                <div>
                  <div className="bd-info-label">Total KM</div>
                  <div className="bd-info-value bd-fare">{booking?.totalKM || ''}</div>
                </div>
                <div>
                  <div className="bd-info-label">Your Commission</div>
                  <div className="bd-info-value bd-commission">{CURRENCY} {booking?.commission || '0'}</div>
                </div>
                {booking?.cancelReason && (
                  <div>
                    <div className="bd-info-label">Cancel Reason</div>
                    <div className="bd-info-value bd-commission">{booking?.cancelReason}</div>
                  </div>
                )}
                {/* add more details here passengers, bags, etc. */}
                {/* <div>
                  <div className="bd-info-label">Passengers</div>
                  <div className="bd-info-value">{booking?.passengers || ''}</div>
                </div>
                <div>
                  <div className="bd-info-label">Large Bags / Medium Bags / Small Bags</div>
                  <div className="bd-info-value">{booking?.largeBags || ''} / {booking?.mediumBags || ''} / {booking?.smallBags || ''}</div>
                </div> */}
              </div>
            </section>
          </div>

          <aside className="bd-side-col">
            <section className="bd-card">
              {/* <h2 className='blink'>Searching. . . .</h2> */}
              {booking?.status === 'Pending' && (
              <div className='loader'> <img
                src="/Images/load.gif"
                alt="load"
              /></div>
              )}
              <h3>Assigned Driver</h3>
              <div className="bd-driver-head">
                {booking?.driver?.profilePic ? (
                  <div className="bd-driver-avatar">
                    <img
                      src={booking.driver.profilePic}
                      alt={booking?.driver?.name || "Driver"}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ) : (
                  <div className="bd-driver-avatar">
                    {booking?.driver?.initials || ""}
                  </div>
                )}

                <div>
                  <div className="bd-driver-name">{booking?.driver?.name || ''}</div>
                  <div className="bh-muted">{booking?.driver?.car || ''}</div>
                  <div className="bh-muted">{booking?.driver?.email || ''}</div>
                  <div className="bh-muted">{booking?.driver?.countryCode || ''} {booking?.driver?.phone || ''}</div>
                </div>

                {/* show ride side OTP if comes */}
                {booking?.otp && booking?.otp !== '' && (
                  <div className="bd-ride-side-otp">
                    <div className="bd-ride-side-otp-label">Ride OTP</div>
                    <div className="bd-ride-side-otp-value">{booking?.otp || ''}</div>
                  </div>
                )}
              </div>
              <div className="bd-rating">
                {'★'.repeat(booking?.driver?.rating || 0)}
                {'☆'.repeat(5 - booking?.driver?.rating || 5)}
                {/* {` ${booking?.driver?.rating || 0}`} — {booking?.driver?.trips?.toLocaleString() || '0'} trips */}
                — {booking?.driver?.trips?.toLocaleString() || '0'} trips
              </div>


              <div className={`bd-driver-status-${booking?.driver?.status?.toLowerCase().replace(/\s+/g, '-')}`}>{booking?.driver?.status || ''}</div>
              <div className="bd-driver-actions">
                {/* <button type="button" className="bh-btn-outline">📞 Call</button> */}
                {/* <button type="button" className="bh-btn-primary">💬 Chat</button> */}
              </div>
            </section>

            <section className="bd-card">
              <h3>Special Requests </h3>
              <p className="bd-special-text">{booking?.specialRequests || ''}</p>
              <div className="bd-tags">
                {booking?.tags && booking.tags.length > 0 && booking.tags.map((tag) => (
                  <span key={tag} className="bd-tag">{tag}</span>
                ))}
              </div>
            </section>
          </aside>
        </div>
      </main>

      {showCancelModal && (
        <div className="cancel-modal-overlay" onClick={() => !cancelling && setShowCancelModal(false)}>
          <div className="cancel-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="cancel-modal-title">
              Please select a reason for cancelling the ride
            </h3>

            <div className="cancel-reason-list">
              {primaryReasons.map((r) => (
                <button
                  key={r.id}
                  type="button"
                  className={`cancel-reason-btn${selectedReason === r.id ? ' selected' : ''}`}
                  onClick={() => handleSelectReason(r)}>
                  {r.label}
                </button>
              ))}
            </div>

            {showOtherReasons && (
              <>
                <div className="cancel-reason-list">
                  {otherReasons.map((r) => (
                    <button
                      key={r.id}
                      type="button"
                      className={`cancel-reason-btn${selectedReason === r.id ? ' selected' : ''}`}
                      onClick={() => {
                        setSelectedReason(r.id);
                        setOtherNote('');
                      }}
                    >
                      {r.label}
                    </button>
                  ))}
                </div>
                <textarea
                  className="cancel-note"
                  placeholder="Anything else. Please provide details of the reason of cancellation."
                  value={otherNote}
                  onChange={(e) => setOtherNote(e.target.value)}
                  rows={3}
                />
              </>
            )}

            <button
              type="button"
              className="cancel-ride-submit"
              disabled={!canSubmit}
              onClick={handleCancelRide}
            >
              {cancelling ? 'Cancelling...' : 'Cancel Ride'}
            </button>
          </div>
        </div>
      )}
    </div>




  );


};

export default BookingDetails;